import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69a9d200"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "object-item-table" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "area-title" }
const _hoisted_5 = { class: "object-title" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" この資料のメタデータを再利用 ")
const _hoisted_7 = { class: "properties" }
const _hoisted_8 = { class: "property-list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "永続的識別子", -1))
const _hoisted_10 = { class: "property-pid" }
const _hoisted_11 = { class: "property-list" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "収集", -1))
const _hoisted_13 = { class: "property-collectionDate" }
const _hoisted_14 = { class: "property-list" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "著者", -1))
const _hoisted_16 = { class: "property-author" }
const _hoisted_17 = { class: "property-list" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "提供機関", -1))
const _hoisted_19 = { class: "property-provider" }
const _hoisted_20 = { class: "property-list" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "閲覧できる場所", -1))
const _hoisted_22 = { class: "property-permission" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result, (data, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "object-item",
        key: index
      }, [
        (data.thumbnailValue)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: `data:image/jpeg;base64,${data.thumbnailValue}`,
              class: "item-thumbnail",
              alt: "サムネイル"
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createBlock(_component_DssIcon, {
              key: 1,
              icon: 'document-book',
              size: 'is-large'
            })),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(data.title), 1),
            _createVNode(_component_AppButton, {
              onClick: ($event: any) => (_ctx.reuse(data.pid)),
              onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.reuse(data.pid)), ["prevent"]), ["space","enter"]),
              styled: 'is-accent',
              buttonId: 'button-reuse'
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_DssIcon, {
                  icon: "arrow-right",
                  style: {"font-size":"18px"}
                })
              ]),
              _: 2
            }, 1032, ["onClick", "onKeydown"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("dl", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("dd", _hoisted_10, _toDisplayString(data.pid), 1)
            ]),
            _createElementVNode("dl", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("dd", _hoisted_13, _toDisplayString(_ctx.formatJst(data.collectionDate)), 1)
            ]),
            _createElementVNode("dl", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("dd", _hoisted_16, _toDisplayString(data.author), 1)
            ]),
            _createElementVNode("dl", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("dd", _hoisted_19, _toDisplayString(data.provider), 1)
            ]),
            _createElementVNode("dl", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("dd", _hoisted_22, _toDisplayString(_ctx.convertPermission(data.permission, '10008')), 1)
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}